/* eslint-disable jsx-a11y/tabindex-no-positive */
import { Alert, Col, Row } from 'antd';
import React from 'react';

import Divider from '@/src/shared/components/Divider';
import Heading from '@/src/shared/components/Heading';
import { handleFormChange } from '@/src/updateProfile/redux/actions';
import { colThirdProps, rowProps } from '@/utils/rowColHelpers';

import usePreventExit from '../../hooks/usePreventExit';
import Checkbox from './components/Checkbox';
import CountryInput from './components/Country';
import Dropdown from './components/Dropdown';
import EmailAddressInput from './components/EmailAddressInput';
import Input from './components/Input';
import MailingStateInput from './components/MailingState';
import OfficeStateInput from './components/OfficeState';
import PasswordInput from './components/PasswordInput';

const ignoreUrls = ['/account/update-profile/submission-confirmation/'];

function FormFields({ form, fields, roles }) {
  const {
    firstName,
    lastName,
    middleName,
    prefix,
    suffix,
    informalName,
    title,
    company,
  } = fields.aboutMe;
  const {
    emailAddress,
    country,
    officeAddress,
    suite,
    city,
    state,
    postalCode,
    phoneNumber,
    extension,
    mobile,
  } = fields.contactInformation;

  const isEmployee = roles.includes('PCI.Everyone');

  usePreventExit(form, ignoreUrls);

  function onChange(field, e) {
    if (typeof e === 'string' || e instanceof String || !e || typeof e === 'number') {
      handleFormChange(field, e);
    } else {
      const {
        target: { value },
      } = e;
      handleFormChange(field, value);
    }
  }

  function renderField(info) {
    switch (info.type) {
      case 'dropdown':
        return <Dropdown key={info.label} info={info} form={form} onChange={onChange} />;
      case 'input':
        return <Input key={info.label} info={info} form={form} onChange={onChange} />;
      case 'checkbox':
        return <Checkbox key={info.label} info={info} form={form} onChange={onChange} />;
      case 'inputPassword':
        return <PasswordInput key={info.label} info={info} form={form} onChange={onChange} />;
      case 'inputEmail':
        return <EmailAddressInput key={info.label} info={info} form={form} onChange={onChange} />;
      case 'inputCountry':
        return <CountryInput key={info.label} info={info} form={form} onChange={onChange} />;
      case 'inputMailingState':
        return <MailingStateInput key={info.label} info={info} form={form} onChange={onChange} />;
      case 'inputOfficeState':
        return <OfficeStateInput key={info.label} info={info} form={form} onChange={onChange} />;
      default: {
        console.warn(`${info.type} is an unknown type.`);
        return null;
      }
    }
  }

  return (
    <>
      <div>
        {isEmployee ? (
          <div>
            <Alert
              message="For changes to your personal information, please contact HR directly.  
                You will not be able to submit changes on the Update Profile screen."
              type="warning"
              showIcon
            />
            <br />
          </div>
        ) : (
          []
        )}
        <Heading type={2} theme="primaryGray" size="md" weight="bold">
          About Me
        </Heading>
        <Row {...rowProps}>
          <Col {...colThirdProps} className="gutter-row">
            {renderField(firstName)}
          </Col>
          <Col {...colThirdProps} className="gutter-row">
            {renderField(middleName)}
          </Col>
          <Col {...colThirdProps} className="gutter-row">
            {renderField(lastName)}
          </Col>
        </Row>
        <Row {...rowProps}>
          <Col lg={4} xs={12} className="gutter-row">
            {renderField(prefix)}
          </Col>
          <Col lg={4} xs={12} className="gutter-row">
            {renderField(suffix)}
          </Col>
          <Col {...colThirdProps} className="gutter-row">
            {renderField(informalName)}
          </Col>
        </Row>
        <Row {...rowProps}>
          <Col {...colThirdProps} className="gutter-row">
            {renderField(title)}
          </Col>
          <Col {...colThirdProps} className="gutter-row">
            {renderField(company)}
          </Col>
        </Row>
      </div>
      <Divider />
      <div>
        <Heading type={2} theme="primaryGray" size="md" weight="bold">
          Contact Information
        </Heading>
        <Row {...rowProps}>{renderField(emailAddress)}</Row>
        <Row {...rowProps}>
          <Col {...colThirdProps} className="gutter-row">
            {renderField(country)}
          </Col>
        </Row>
        <Row {...rowProps}>
          <Col {...colThirdProps} className="gutter-row">
            {renderField(officeAddress)}
          </Col>
          <Col lg={4} xs={24} sm={12} className="gutter-row">
            {renderField(suite)}
          </Col>
          <Col {...colThirdProps} className="gutter-row">
            {renderField(city)}
          </Col>
        </Row>
        <Row gutter={16}>
          <Col lg={8} md={12} className="gutter-row">
            {renderField(state)}
          </Col>
          <Col lg={4} xs={24} sm={12} className="gutter-row">
            {renderField(postalCode)}
          </Col>
        </Row>
        <Row {...rowProps}>
          <Col {...colThirdProps} className="gutter-row">
            {renderField(phoneNumber)}
          </Col>
          <Col lg={4} xs={24} sm={12} className="gutter-row">
            {renderField(extension)}
          </Col>
          <Col {...colThirdProps} className="gutter-row">
            {renderField(mobile)}
          </Col>
        </Row>
      </div>
      <Divider />
      {/* <div>
        <Heading type={2} theme="primaryGray" size="md" weight="bold">
          Mailing Information
        </Heading>
        {renderField(extraAddress)}
        <Row {...rowProps}>
          <Col {...colThirdProps} className="gutter-row">
            {renderField(poBoxNumber)}
          </Col>
          <Col {...colThirdProps} className="gutter-row">
            {renderField(altCity)}
          </Col>
        </Row>
        <Row {...rowProps}>
          <Col {...colThirdProps} className="gutter-row">
            {renderField(altState)}
          </Col>
          <Col lg={4} sm={24} className="gutter-row">
            {renderField(altPostalCode)}
          </Col>
        </Row>
      </div> */}
    </>
  );
}

export default FormFields;
